import React from 'react';
import {
  Pressable,
  StyleSheet,
  type StyleProp,
  type ViewStyle,
} from 'react-native';

import { spacing } from '../../theme';

/** Glyph size for ⓘ and sparkle-pencil inside this control. */
export const FORM_FIELD_TRAILING_ICON_SIZE = 16;

export type FormFieldTrailingIconProps = {
  onPress: () => void;
  accessibilityLabel: string;
  accessibilityHint?: string;
  testID?: string;
  children: React.ReactNode;
  style?: StyleProp<ViewStyle>;
};

/**
 * Trailing label control (ⓘ or text-assist). Glyph size is
 * {@link FORM_FIELD_TRAILING_ICON_SIZE}. hitSlop 8 matches Opportunity Info.
 */
export const FormFieldTrailingIcon: React.FC<FormFieldTrailingIconProps> = ({
  onPress,
  accessibilityLabel,
  accessibilityHint,
  testID,
  children,
  style,
}) => (
  <Pressable
    onPress={onPress}
    style={({ pressed }) => [styles.button, pressed && styles.pressed, style]}
    accessibilityLabel={accessibilityLabel}
    accessibilityRole="button"
    accessibilityHint={accessibilityHint}
    hitSlop={8}
    testID={testID}
  >
    {children}
  </Pressable>
);

const styles = StyleSheet.create({
  button: {
    padding: spacing.infoIconPadding,
  },
  pressed: {
    opacity: 0.65,
  },
});
